import { useEffect, useRef } from 'react';

const useClickOutside = (consumerHandler) => {
  const ref = useRef();

  useEffect(() => {
    const listener = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        consumerHandler();
      }
    };

    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, consumerHandler]);

  return ref;
};

export default useClickOutside;
